export const getPbxIdFromJiveResourceName = (jrn: string | undefined) => jrn?.split(':')[4] ?? ''

export const getPbxUserIdFromJiveResourceName = (jrn: string | undefined) => jrn?.split('/')[1] ?? ''
